import { parseAsBoolean, useQueryState } from 'nuqs'
import { useMemo } from 'react'

import FeedbackIconProvider from '@/lib/provider/FeedbackIconProvider'
import ProductDetailsCard from '@components/productDetails/ProductDetailsCard'
import TaskProductDetailsCard from '@components/productDetails/TaskProductDetailsCard'
import ShelfDetails from '@components/shelfDetails/ShelfDetails'
import useShelfDetails from '@components/shelfDetails/useShelfDetails'
import StoreMap from '@components/storeMap/StoreMap'
import { usePageHeader } from '@hooks/useHeader.ts'
import { usePlacementsByGtin } from '@state/product'
import { stockLevelFacingProducer } from '@utils/facingProducer.ts'

// usually only used for the mobile view when linking from a task or from a product list

function StoreMapRoute() {
  usePageHeader({ isFullPage: true })
  const { shelfId, setShelfId } = useShelfDetails()
  const [showTaskProductDetailsCard] = useQueryState('with-tasks', parseAsBoolean.withDefault(false))
  const [gtin] = useQueryState('gtin')
  const resolvedGtin = gtin ?? undefined
  const placements = usePlacementsByGtin(resolvedGtin)

  const facingProducer = useMemo(
    () => stockLevelFacingProducer(resolvedGtin),
    [resolvedGtin]
  )

  return (
    <div className='relative size-full'>
      <FeedbackIconProvider>
        <StoreMap
          showToolbar={true}
          selectedShelfId={shelfId}
          setSelectedShelfId={setShelfId}
          highlightedShelves={placements}
        />

        {/* Show product details only when no shelf details are visible */}
        {!shelfId && (
          <div className='absolute'>
            {showTaskProductDetailsCard ?
              <TaskProductDetailsCard selectedGtin={resolvedGtin} /> :
              <ProductDetailsCard selectedGtin={resolvedGtin} />
            }
          </div>
        )}
      </FeedbackIconProvider>

      <ShelfDetails
        shelfId={shelfId}
        onShelfIdChange={setShelfId}
        facingProducer={facingProducer}
      />
    </div>
  )
}

export default StoreMapRoute